import { Checkbox, Spinner } from '@zillow/constellation';
import { checkForMutationSuccess } from 'API/checkForMutationSuccess';
import { usePatchTaskMutation } from 'API/order/OrderTaskAPI';
import React from 'react';
import { useSelectCurrentOrderId } from 'selectors/order/selectCurrentOrder';
import { convertIOrderTaskDataToIUpdateOrderTaskRequest, IOrderTaskData } from 'types/tasks';
import { assertDefined } from 'utilities/Assertions';

interface ICompleteTaskProps {
  task: IOrderTaskData;
}

export const CompleteTask: React.FC<ICompleteTaskProps> = ({ task }) => {
  const orderId = useSelectCurrentOrderId();
  assertDefined(orderId);
  const [patchTask, { isLoading }] = usePatchTaskMutation();

  const onChange = async () => {
    const taskOrderRequest = convertIOrderTaskDataToIUpdateOrderTaskRequest({
      ...task,
      completed: true,
    });
    const result = await patchTask({ orderId, body: taskOrderRequest });
    checkForMutationSuccess(result, 'task completion', 'Error completing the task.');
  };
  return (
    <>
      {isLoading && <Spinner />}
      {!isLoading && (
        <Checkbox checked={task.completed} onChange={onChange} data-test-id={`complete-task-${task.id}`} />
      )}
    </>
  );
};
